/* eslint-disable react/display-name */
import React from 'react';
import { components as ReactSelectComponents } from 'react-select';

import * as Interfaces from '../interfaces';

const Input = (
  props: React.ComponentProps<typeof ReactSelectComponents.Input> & {
    selectProps?: Interfaces.SelectComponentProps;
  }
) => {
  return (
    <ReactSelectComponents.Input
      {...props}
      data-testid={`${props.selectProps?.name}-AutoCompleteInput`}
    />
  );
};

export default Input;
